import { type PropsWithChildren, useEffect } from "react";
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import { View } from "tamagui";

export const FormLabel: React.FC<
  PropsWithChildren<{
    labelActive?: boolean;
    label?: string;
    onLabelPress?: () => void;
  }>
> = ({ labelActive, label, onLabelPress, children }) => {
  const fontSize = useSharedValue(labelActive ? 12 : 16);
  const top = useSharedValue(labelActive ? -7 : 14);

  useEffect(() => {
    fontSize.value = withTiming(labelActive ? 12 : 16, {
      duration: 300,
      easing: Easing.inOut(Easing.quad),
    });
    top.value = withTiming(labelActive ? -7 : 14, { duration: 300 });
  }, [fontSize, top, labelActive]);

  const animatedStyle = useAnimatedStyle(() => ({
    fontSize: fontSize.value,
    top: top.value,
  }));

  return (
    <View position="relative" flex={1}>
      {label && (
        <Animated.Text
          onPress={onLabelPress}
          style={[
            {
              fontWeight: "300",
              fontFamily: "Inter",
              position: "absolute",
              left: 13,
              backgroundColor: "#fff",
              paddingHorizontal: 10,
              color: "#858585",
              zIndex: 10,
            },
            animatedStyle,
          ]}
        >
          {label}
        </Animated.Text>
      )}
      {children}
    </View>
  );
};
